export const getOthers = (state) => state.others
